// Content pools. Tone: CT-native, funny, never hateful. No real people, projects, or brands.
// Post templates, DMs, and event text are added in the milestones that use them.

export const HANDLE_FRAGMENTS = [
  "based", "wagmi", "ngmi", "sol", "degen", "0x", "anon", "chad", "ser", "fren", "gm", "gn",
  "ape", "moon", "pump", "dump", "bag", "bags", "rekt", "alpha", "beta", "sigma", "giga", "mega",
  "ultra", "turbo", "hyper", "meta", "zk", "layer", "chain", "block", "hash", "node", "validator",
  "staker", "farmer", "sniper", "whale", "shrimp", "crab", "plankton", "dolphin", "shark", "fish",
  "bull", "bear", "crabby", "diamond", "paper", "hands", "hodl", "lambo", "wen", "soon", "fud",
  "shill", "kol", "caller", "sensei", "sage", "oracle", "wizard", "goblin", "frog", "pepe_ish",
  "doge_ish", "cat", "dog", "hamster", "monke", "penguin", "otter", "fox", "owl", "rat", "bird",
  "cope", "seethe", "vibes", "trench", "trenches", "mint", "flip", "floor", "sweep", "rug", "dev",
  "devv", "builder", "maxi", "minimalist", "yield", "apy", "points", "airdrop", "tge", "season",
  "bridge", "swap", "gas", "gwei", "lamport", "sats", "stack", "stacker", "printer", "brrr",
  "liquid", "illiquid", "exit", "entry", "liq", "long", "short", "perp", "fomo", "jomo", "probably",
  "nothing", "something", "maybe", "never", "always", "early", "late", "cooked", "cooking", "chef",
  "kitchen", "intern", "ceo", "cto", "vc", "angel", "seed", "series", "round", "unlock", "vest",
  "cliff", "emission", "inflation", "deflation", "burn", "mint", "supply", "cap", "mcap", "fdv",
  "tvl", "dao", "gov", "vote", "proposal", "multisig", "cold", "hot", "wallet", "seed_phrase_no",
  "notyourkeys", "selfcustody", "onchain", "offchain", "rollup", "sequencer", "prover", "verifier",
  "mev", "searcher", "builder_", "relayer", "keeper", "liquidator", "arb", "arber", "bot", "botbuster",
  "sleuth", "detective", "onchainsleuth", "forensic", "tracer", "watcher", "scout", "ranger", "pilot",
  "astro", "cosmo", "lunar", "solar", "stellar", "nova", "comet", "rocket", "launch", "launchpad",
  "candle", "wick", "green", "red", "pumpamental", "fundamental", "technical", "ta", "chart", "line",
  "up", "only", "number", "go", "brr", "fren_", "frens", "gmi", "lfg", "iykyk", "ser_", "probably_",
];

export const DISPLAY_NAME_POOL = [
  "ChartSensei", "0xBigBags", "GmFrens", "TrenchWizard", "CandleWhisperer", "DiamondDave",
  "PaperPaul", "AirdropAlice", "MintMaxi", "RugRadar", "FloorSweeper", "AlphaAnon", "WenLambo",
  "ChartGoblin", "PointsFarmer", "BagHolderBen", "GigaBrainGabe", "CopeCaptain", "NGMI_Nina",
  "MoonMika", "DegenDoug", "SniperSam", "HypeHarvester", "FrogFather", "ShrimpSzn",
];

export const HANDLE_POOL = [
  "gmfrens_", "0xbigbags", "chartsensei", "trenchwizard", "candlewhisper", "diamond_dave",
  "paperpaul", "airdropalice", "mintmaxi", "rugradar", "floorsweeper", "alphaanon", "wenlambo",
  "chartgoblin", "pointsfarmer", "bagholderben", "gigabrain_gabe", "copecaptain", "ngmi_nina",
  "moonmika", "degendoug", "snipersam", "hypeharvest", "frogfather", "shrimpszn",
];

export const PRESET_BIOS = [
  "Not financial advice. Barely advice.",
  "Professional bag holder. Amateur everything else.",
  "Farming points since before it was cool.",
  "Probably nothing. Definitely something.",
  "I read the whitepaper. The first paragraph.",
  "Down bad, up good, mostly sideways.",
];

// Token names: combined as `${A} ${B}` with ticker derived. 30 x 30 = 900 combos.
export const TOKEN_WORDS_A = [
  "Baby", "Giga", "Turbo", "Based", "Sad", "Angry", "Sleepy", "Rich", "Broke", "Space", "Cyber",
  "Wet", "Tiny", "Chonky", "Golden", "Laser", "Retro", "Mega", "Sigma", "Smol", "Chill", "Hyper",
  "Cosmic", "Dark", "Lucky", "Moon", "Pixel", "Royal", "Feral", "Quantum",
];

export const TOKEN_WORDS_B = [
  "Frog", "Cat", "Dog", "Hamster", "Penguin", "Otter", "Monke", "Goose", "Duck", "Capybara",
  "Shiba", "Pug", "Owl", "Fox", "Rat", "Whale", "Shrimp", "Crab", "Bonk", "Wojak", "Chad",
  "Gremlin", "Goblin", "Sloth", "Llama", "Bean", "Toast", "Noodle", "Pickle", "Potato",
];

export const PROTOCOL_NAMES = [
  "ZkBridgeless", "LayerNull", "Restakoor", "OmniPipe", "Liquidzz", "Sequencr", "Rollupia",
  "PointsDAO", "Yieldra", "Stakehouse", "ProverNet", "Bridgefy", "Swapadoo", "Interchainz",
  "Modularis", "DataBlobs", "IntentFi", "Abstractr", "Paymasterz", "Gasless Labs", "Vaultopia",
  "Lendr", "Borrowz", "Perpetuo", "OracleNine", "Keepr", "Relayr", "Zapper Zone", "ChainWeave",
  "Settlr", "Finality", "Sovereign Stack", "Appchainz", "BlobStream", "ShardLand", "Validia",
  "Hashflowz", "Mempoolio", "Blockspace Co", "Epochs", "Slashless", "Nodekeep",
];

export const NFT_COLLECTION_NAMES = [
  "Pixel Pals", "Bored Blobs", "Moon Moles", "Degen Ducks", "Laser Llamas", "Sad Sloths",
  "Cyber Crabs", "Rich Rats", "Goblin Gang", "Frog Friends", "Toast Club", "Noodle Nation",
  "Pickle Punks", "Space Shibas", "Chonk Kingdom", "Wojak World", "Turbo Turtles", "Gm Gremlins",
  "Floor Lords", "Mint Monsters", "Retro Robots", "Feral Foxes", "Quantum Quokkas", "Dark Doges",
  "Lucky Lemurs", "Smol Squids", "Hyper Hamsters", "Golden Geese", "Chill Capybaras", "Royal Rugs",
  "Paper Penguins", "Diamond Dolphins",
];

export const LOADING_TIPS = [
  "Never share your seed phrase. Not even with a frog.",
  "If the dev holds 35%, the dev holds the exit.",
  "Points are not money until they are.",
  "Touching grass reduces heat. Science.",
  "Copytraders follow your calls. Your trust follows your results.",
  "A coin that only goes up is a coin you haven't sold yet.",
];

// ---------------------------------------------------------------- Chirp (M4)
// Variables: {ticker} {name} {pct} {mcap} {handle} {target}

export type PlayerPostType = "gm" | "meme" | "alpha" | "fud" | "shill" | "thread" | "callout" | "reply";

/** Three variations per player post type (spec 11.2). */
export const PLAYER_POST_TEMPLATES: Record<PlayerPostType, string[]> = {
  gm: ["gm", "gm frens. today we build (or ape)", "gm to everyone except the guy who sold the bottom"],
  meme: [
    "me explaining to my family why I'm down 80% but 'early'",
    "chart looks like my sleep schedule 📉📈📉",
    "devs: 'utility soon'. the utility: 🫠",
  ],
  alpha: [
    "${ticker} looks ready. chart is coiled, holders growing. NFA 🚀",
    "been watching ${ticker} all day. this one has legs. {mcap} mcap is early",
    "if you're not in ${ticker} at {mcap} I can't help you",
  ],
  fud: [
    "${ticker} chart screams exit liquidity. be careful out there",
    "dev wallet on ${ticker} looks sus. not touching it",
    "${ticker} at {mcap}? you're the exit, anon",
  ],
  shill: [
    "loaded more ${ticker}. we're so early it hurts",
    "${ticker} community is the strongest on the timeline. not even close",
    "${ticker} is not a coin, it's a movement. ape responsibly 🫡",
  ],
  thread: [
    "🧵 how to spot a rug before it pulls: dev bag size, holder count, liquidity. a thread 1/7",
    "🧵 what I learned losing money so you don't have to 1/9",
    "🧵 bonding curves explained like you're a sleep-deprived degen 1/6",
  ],
  callout: [
    "@{target} you shilled that coin and dumped on your own followers. receipts below 👇",
    "not gonna name names... ok fine, @{target}. explain the wallet activity",
    "@{target} every call you make rugs within a day. coincidence?",
  ],
  reply: ["this ^", "ser this is the alpha", "saving this before it gets deleted"],
};

export type Personality = "alpha" | "doomer" | "shillbot" | "sleuth" | "influencer" | "builder" | "memelord";

export const NPC_POST_TEMPLATES: Record<Personality, string[]> = {
  alpha: [
    "${ticker} is the play today. {mcap} and climbing",
    "quietly accumulating ${ticker}. you didn't hear it from me",
    "${ticker} chart is the cleanest on the timeline rn",
  ],
  doomer: [
    "${ticker} down {pct} and you're still holding? brave",
    "market's cooked. see you all at the bottom",
    "every bounce is a chance to sell. that's it. that's the tweet",
  ],
  shillbot: [
    "🚀🚀 ${ticker} 🚀🚀 NEXT 100X 🚀🚀 DONT MISS",
    "${ticker} ${ticker} ${ticker} 💎🙌",
    "just aped ${ticker}. who's with me 🦍",
  ],
  sleuth: [
    "🚨 ${ticker} dev wallet just dumped the bag. that's a rug. stay safe",
    "traced ${ticker} funding to the same wallets as the last 3 rugs. not financial advice, just facts",
    "👀 looking into ${ticker}. thread soon",
  ],
  influencer: ["gm to everyone except bears", "what are we aping today?", "reminder: take profits. or don't. I'm not your mom"],
  builder: [
    "shipping > shilling. back to the code",
    "🧵 a few thoughts on why most tokens die in 48h 1/5",
    "building through the noise. same as always",
  ],
  memelord: [
    "${ticker} holders when the chart goes sideways for 5 minutes: 😱",
    "my portfolio is a meme and I'm the punchline",
    "bought the top again. it's a lifestyle at this point",
  ],
};

export const NEWS_TEMPLATES = {
  graduated: ["🎓 ${ticker} just graduated to the AMM. {mcap} mcap", "${ticker} graduated. curve's done, now it's a real pool"],
  rug: ["🚨 ${ticker} rugged. dev dumped everything", "RIP ${ticker}. dev took the exit"],
  newcoin: ["🆕 ${ticker} ({name}) just launched on Pumpr", "fresh coin: ${ticker}. dev holds {pct}"],
  bull: ["📈 green everywhere. we're so back"],
  crash: ["📉 it's over. blood in the trenches"],
};

export const REPLY_TEMPLATES = {
  positive: ["based", "this is the way", "ser yes ser", "aped 🫡", "W post", "bullish on this take", "saving this"],
  negative: ["ngmi", "cope", "who asked", "this aged badly", "exit liquidity detected", "L take"],
  neutral: ["gm", "👀", "wen", "interesting...", "first", "probably nothing"],
};

export const TRADER_NAME_PARTS = HANDLE_FRAGMENTS;

// ---------------------------------------------------------------- events (M7)
// Scam templates are deliberately obvious: they double as a scam-awareness lesson.

export const PHISHING_DMS = [
  { from: "0xSupp0rt_Team", body: "Hello sir we detected an issue with your wallet 🚨 Please verify at wallet-fix-portal.xyz within 10 minutes or funds will be frozen." },
  { from: "pumpr_admin_official", body: "Congrats!! You've been selected for a VIP whitelist 🎉 Connect and sign here to claim: pumpr-vip-claim.click" },
  { from: "ChirpSafetyDesk", body: "Your account was reported for impersonation. Appeal now or lose your handle forever: chirp-appeal-center.net" },
  { from: "{handle}_backup", body: "gm ser, it's me from my backup account. quick favor, send me your seed phrase so I can restore a stuck tx? 🙏" },
];

export const FAKE_CLAIMS = [
  { from: "{protocol} (official?)", body: "🪂 {protocol} airdrop is LIVE! Claim before it expires: {slug}-claim.app — connect wallet and approve to receive tokens." },
  { from: "{protocol}Drops", body: "You're eligible for 4,200 ${ticker}! Snapshot is final. Approve the claim contract here: {slug}-rewards.io" },
];

export const SCAM_LESSONS = [
  "Real projects never DM you first and never need your seed phrase.",
  "\"Approve\" on a fake claim site lets the scammer move your funds.",
  "Urgency + a weird domain = scam. Every time.",
];

export const COLLAB_OFFERS = [
  "Hey, big fan 🙏 We'd love a quick post about ${ticker}. Paying {pay} for one shill. No need to buy, just vibes.",
  "Partnership opportunity! {pay} for a tweet about ${ticker}. Community is strong, chart is about to send. Interested?",
];

export const REKT_LINES = [
  "You're not broke, you're pre-rich.",
  "The chart did what charts do.",
  "Down 100% means you can't go any lower. Probably.",
  "Ser, this is a Wendy's.",
  "Every legend has a rekt arc.",
];

export const RANK_UP_LINES = [
  "The timeline noticed.",
  "Bags got heavier. So did your reputation.",
  "Main character energy.",
  "Your mom still doesn't understand what you do.",
];

/**
 * Currency names (production roadmap §2). Change them here, not in code.
 * WUSD = World USD, the in-game stablecoin (net worth and rank use it).
 * DGN = the native "gas" coin every on-chain action burns a little of.
 */
export const CURRENCY = {
  main: { code: "WUSD", name: "World USD", symbol: "W$" },
  gas: { code: "DGN", name: "Degen gas", icon: "⛽" },
} as const;

/**
 * Real-world events shown on billboards and in the Events app (researched 2026-10-04).
 * Informational listings only: no affiliation implied. Shown only while upcoming (by device date).
 * In production these become ad-server slots managed from the admin dashboard (roadmap Phase 2).
 */
export interface RealEvent {
  name: string;
  start: string; // ISO date
  end: string;
  city: string;
  venue: string;
  color: string;
}

export const REAL_EVENTS: RealEvent[] = [
  { name: "TOKEN2049 Singapore", start: "2026-10-07", end: "2026-10-08", city: "Singapore", venue: "Marina Bay Sands", color: "#7c3aed" },
  { name: "Blockfest Africa", start: "2026-10-22", end: "2026-10-23", city: "Lagos", venue: "National Theatre", color: "#16a34a" },
  { name: "Devcon 8", start: "2026-11-03", end: "2026-11-06", city: "Mumbai", venue: "Jio World Centre", color: "#2563eb" },
  { name: "Solana Breakpoint", start: "2026-11-15", end: "2026-11-17", city: "London", venue: "Olympia London", color: "#9333ea" },
  { name: "TOKEN2049 Dubai", start: "2027-04-21", end: "2027-04-22", city: "Dubai", venue: "Venue TBA", color: "#7c3aed" },
];

/** Events that haven't ended yet, soonest first. */
export function upcomingRealEvents(now: Date, limit = 4): RealEvent[] {
  const today = now.toISOString().slice(0, 10);
  return REAL_EVENTS.filter((e) => e.end >= today)
    .sort((a, b) => a.start.localeCompare(b.start))
    .slice(0, limit);
}

/** "Oct 7–8" style range. */
export function eventDates(e: RealEvent): string {
  const m = (iso: string) => new Date(`${iso}T12:00:00Z`).toLocaleString("en-US", { month: "short", timeZone: "UTC" });
  const d = (iso: string) => Number(iso.slice(8, 10));
  return m(e.start) === m(e.end) ? `${m(e.start)} ${d(e.start)}–${d(e.end)}` : `${m(e.start)} ${d(e.start)} – ${m(e.end)} ${d(e.end)}`;
}
